import React from "react";
import "./loadingScreen.css";
import { WirderMark } from "./components/wirderMark";

/**
 * The initial brand splash. Shown only for the brief pre-auth window before
 * `rehydrateAuth()` resolves (`authState.status === "loading"`). Once the
 * player is known to be signed in, the animated {@link ConnectingScreen} takes
 * over and owns the session load; a signed-out player goes to the sign-in
 * screen. This screen is purely presentational.
 */
export function LoadingScreen() {
  return (
    <div className="screen splash">
      <div className="splash__center">
        <WirderMark className="splash__logo" />
        <div className="display splash__word">Wirder</div>
        <div className="eyebrow splash__tag">
          Daily&nbsp;&nbsp;Hunt&nbsp;&nbsp;For&nbsp;&nbsp;Rare&nbsp;&nbsp;Words
        </div>
      </div>
      <div className="splash__foot">
        <div className="splash__dots" aria-label="Loading">
          <i></i>
          <i></i>
          <i></i>
        </div>
        <div className="splash__defn">
          <div className="splash__defn-head">
            Wirder <span className="pron">(wer&middot;der)</span> <span className="pos">n.</span>
          </div>
          <div className="splash__defn-body">A bird with a passion for finding rare words.</div>
        </div>
      </div>
    </div>
  );
}
